import { MatchDetailItemFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { isUsingSystemMatchEvents } from '@amf/shared/data/Match';
import MatchJumbotronEventHandler from '@amf/shared/components/match/MatchJumbotronEventHandler';
import MatchJumbotronTimer from '@amf/shared/components/match/MatchJumbotronTimer';
import classNames from 'classnames';

import MatchJumbotronStatus from './MatchJumbotronStatus';

type MatchJumbotronProps = {
  match: MatchDetailItemFragment;
  className?: string;
};

function MatchJumbotron({ match, className }: MatchJumbotronProps) {
  const { t } = useTranslate();
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 600], [-300, 0]);
  const scale = useTransform(scrollY, [0, 600], [0.8, 1]);

  if (!isUsingSystemMatchEvents(match)) return null;
  return (
    <motion.div className={classNames('MatchJumbotron', className)} style={{ y, scale }}>
      <motion.div
        className='MatchJumbotron__box'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className='MatchJumbotron__team'>
          <span>{match.home?.team.name ?? '?'}</span>
          <small>{t('match.roster.home')}</small>
        </div>
        <div className='MatchJumbotron__center'>
          <div
            className={classNames('MatchJumbotron__score', {
              'MatchJumbotron__score--small': !match.standardMatch,
            })}
          >
            {match.score}
          </div>
          {!match.dateEnd && <MatchJumbotronTimer match={match} />}
        </div>
        <div className='MatchJumbotron__team'>
          <span>{match.visiting?.team.name ?? '?'}</span>
          <small>{t('match.roster.visiting')}</small>
        </div>
        <MatchJumbotronEventHandler match={match} />
      </motion.div>
      <MatchJumbotronStatus match={match} />
    </motion.div>
  );
}

export default MatchJumbotron;
